import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, Empty } from "../components/ui-helpers";
import { Folders } from "@phosphor-icons/react";

export default function ReadinessEvidence() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/evidence?readiness=1").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div>
      <PageHeader title="Readiness Evidence Locker"
        subtitle="Evidence staged for new or changed (future-enforceable) standards, ahead of enforcement." />
      {items === null ? null : items.length === 0 ? (
        <Empty title="No readiness evidence yet"
          hint="Evidence linked to a future-enforceable standard's requirements will appear here automatically. Link evidence to an upcoming standard in the Evidence Repository." />
      ) : (
        <div className="border border-border" data-testid="readiness-evidence-list">
          <table className="text-sm w-full">
            <thead className="bg-secondary">
              <tr>{["Evidence", "Type", "Period", "Linked Reqs", "Version"].map((h) => (
                <th key={h} className="px-4 py-2 text-left font-semibold">{h}</th>))}</tr>
            </thead>
            <tbody>
              {items.map((e) => (
                <tr key={e.id} className="border-t border-border" data-testid={`readiness-evidence-${e.id}`}>
                  <td className="px-4 py-3 font-medium flex items-center gap-2"><Folders size={15} /> {e.name}</td>
                  <td className="px-4 py-3">{e.evidence_type}</td>
                  <td className="px-4 py-3">{e.period_start || "—"}{e.period_end ? ` → ${e.period_end}` : ""}</td>
                  <td className="px-4 py-3">{(e.linked_requirements || []).length}</td>
                  <td className="px-4 py-3">{e.version || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
